import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/layout/Layout';

// Eagerly loaded - main user flows
import { TodayPage } from './pages/TodayPage';
import { InventoryPage } from './pages/InventoryPage';

// Lazy loaded - less frequently used pages
const ProductEditPage = lazy(() => import('./pages/ProductEditPage').then(m => ({ default: m.ProductEditPage })));
const ReportsPage = lazy(() => import('./pages/ReportsPage').then(m => ({ default: m.ReportsPage })));
const SettingsPage = lazy(() => import('./pages/SettingsPage').then(m => ({ default: m.SettingsPage })));

// Loading fallback for lazy loaded pages
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[50vh]">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600" />
  </div>
);

// Wrapper for lazy loaded pages
const LazyPage = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader />}>
    {children}
  </Suspense>
);

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <TodayPage />
      </Layout>
    ),
  },
  {
    path: '/inventory',
    element: (
      <Layout>
        <InventoryPage />
      </Layout>
    ),
  },
  {
    path: '/inventory/:productId',
    element: (
      <Layout>
        <LazyPage>
          <ProductEditPage />
        </LazyPage>
      </Layout>
    ),
  },
  {
    path: '/reports',
    element: (
      <Layout>
        <LazyPage>
          <ReportsPage />
        </LazyPage>
      </Layout>
    ),
  },
  {
    path: '/settings',
    element: (
      <Layout>
        <LazyPage>
          <SettingsPage />
        </LazyPage>
      </Layout>
    ),
  },
]);
